import Api from "./Api";

const API_URL = "/api/calendar";

const CalendarService = {
  async getWorkdayCalendarSettings(storefrontNumber) {
    const url = `${API_URL}/getWorkdayCalendarSettings/${storefrontNumber}`;

    return await Api.fetch(url, { method: "GET" });
  },
};

export default CalendarService;
